module.exports = __webpack_public_path__ + "static/media/sidebar-ppm.e7a4d59e.png";